import { defineGlobal, getGlobalObject } from '@datadog/browser-core';
import { makeRumPublicApi, startRum } from '@datadog/browser-rum-core';
export var datadogRum = makeRumPublicApi(startRum);
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);
//# sourceMappingURL=rum.entry.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/@datadog/browser-rum/esm/boot/rum.entry.js
// module id = ../../../../@datadog/browser-rum/esm/boot/rum.entry.js
// module chunks = 5